import React, { useEffect } from "react";
import { Container, Row, Col, Breadcrumb } from "react-bootstrap";


import "../styles/Dashboard.css";
import LineChartComponent from "../components/LineGraphComponent/LineChartComponent";
import BarChartComponent from "../components/GraphComponent/BarChartComponent";
import TableComponent from "../components/TableComponent/TableComponent";
import FarmerMap from "../components/FarmerMap/FarmerMap";
import ProductsComponent from "../components/ProductsComponent/ProductsComponent";
import UserComponent from "../components/UserComponent/UserComponent";
import TitleComponent from "../components/TitleComponent/TitleComponent";
import CustomerComponent from "../components/CustomerComponent/CustomerComponent";
import FeedbacksComponent from "../components/FeedbacksComponent/FeedbacksComponent";
import { ICONS } from "../constants/constants";
import { Link, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  handleGetSupplierDetails,
  handleDeleteSupplier,
  handleGetSupplierOrders,
  handleGetSupplierRating,
} from "../store/actions/suppliersActions";
import Loader from "../assets/images/loader.gif";
const Supplier = () => {
  const location = useLocation();
  const supplier = location.state?.supplier; // Access supplier data
  const dispatch = useDispatch();
  const productsArray = [
    /* Your data here */
  ];

  const { user } = useSelector((state) => state.user);
  const supplierId = supplier?.id;

  const customersList = user?.adminUsers?.filter(
    (user) => user.role === "farmer"
  );

  // Get data from the Redux store
  const { supplierOrderList, isLoading, error } = useSelector(
    (state) => state.supplier
  );
   const { supplierDetails } = useSelector((state) => state.supplier);
  

   // const { farmerFarmDetails, farmerDetails } = useSelector((state) => state.farmer);
  const supplierOrders = supplierOrderList?.orders;

  // Fetch supplier orders when the component mounts or when the supplierId changes
  useEffect(() => {
    if (supplierId) {
      dispatch(handleGetSupplierDetails(supplierId));
      dispatch(handleGetSupplierOrders(supplierId)); // Fetch supplier orders
      dispatch(handleGetSupplierRating(supplierId)); // Fetch supplier rating
    }
  }, [dispatch, supplierId]);

  const supplierRating = useSelector((state) => state.supplier.supplierRating);


  const userData = {
    id: supplierDetails?.data?.supplier?.id || "Andrew",
    name: supplierDetails?.data?.supplier?.name || "Andrew",
    userdatarole: supplierDetails?.data?.supplier?.role,
    // email: supplier?.email || "user@gmail.com",
    joinedDate: supplierDetails?.data?.supplier?.joinedDate || "8/2/2024",
    cnic: supplierDetails?.data?.supplier?.cnic || "34000-90909090-7",
    mobile: supplierDetails?.data?.supplier?.mobile_number || "+967654546655",
    city: supplierDetails?.data?.supplier?.city || "Rawat",
    address: supplierDetails?.data?.supplier?.address || "st#3, H#4, gulberg green",
    company: supplierDetails?.data?.supplier?.company?.name || "Baghe",
    account_status: supplierDetails?.data?.supplier?.account_status,
    otp_status: supplierDetails?.data?.supplier?.otp_status,
  };

  const userDetailsArray = [
    { label: "CNIC/NTN", value: userData.cnic },
    { label: "Mobile Number", value: userData.mobile },
    { label: "City", value: userData.city },
    { label: "Address", value: userData.address },
    { label: "Company", value: userData.company },
  ];

  const tableTitle = "Orders";

  const columns = [
    "OrderID",
    "OrderBy",
    "OrderFrom",
    "ProductNumber",
    "OrderStatus",
    ...(user?.role !== "manager" ? ["TotalAmount"] : []),
    "Actions",
  ];

  // Example supplierOrders array (replace with actual data source)
  // const supplierOrders = [
  //   {
  //     id: "47ea1248-2b1e-4437-96e0-3f74e5ddcbff",
  //     order_status: "Pending",
  //     quantity: 10,
  //     totalCost: "1200.00",
  //   },
  // ];

  // Map supplier orders to the table data structure
  // Map supplier orders to the table data structure
  const data = supplierOrders?.map((order) => {
    // Extracting reusable variables for clarity
    const orderId = order?.id || "N/A";
    const orderBy = order?.farmerUser?.name || "N/A";
    const orderFrom = order?.supplierUser?.name || "N/A";
    // const productName = order?.product?.productName || "N/A";
    // const quantity = order?.quantity || "N/A";
    // const productName = order?.orderItems[0].product?.productName;
    // const quantity = order?.orderItems[0].quantity || "N/A";
    const ProductNumber= order?.orderItems?.length || 1; 
    const orderStatus = order?.order_status || "N/A";
    const totalAmount = order?.totalCost || "N/A";

    // Actions column with consistent logic
    const actions = (
      <>
        <Link
          to={`/order-details/${orderId}`}
          state={{ order }} // Correctly pass order data
          rel="noopener noreferrer"
        >
          <img src={ICONS.viewIcon} alt="View" className="tick-icon" />
        </Link>
        {/* <img src={ICONS.editIcon} alt="Edit" className="cross-icon" />
        <img src={ICONS.downloadIcon} alt="Download" className="cross-icon" /> */}
      </>
    );

    // Return mapped order data, omit TotalAmount for manager role
    const row = {
      OrderID: orderId,
      OrderBy: orderBy,
      OrderFrom: orderFrom,
      ProductNumber: ProductNumber,
      // Quantity: quantity,
      OrderStatus: orderStatus,
      Actions: actions,
    };

    if (user?.role !== "manager") {
      row.TotalAmount = totalAmount;
    }

    return row;
  });


  // Pass dynamically if these features should be shown
  const showSearchBar = true; // Change to false to hide search bar
  const searchplaceholder = "Search by ID, Order By,Order Placed";
  const showFilter = false; // Change to false to hide filter
  const showTabs = true; // Change to false to hide tabs (Approved/Not Approved)
  const showColors = false;

  // Transform supplierRating into feedbackData format
  const ratings =
  supplierDetails?.data?.supplier?.receivedRatings || [];

const averageRating =
  ratings.length > 0
    ? ratings.reduce((sum, rating) => sum + (rating?.star_count || 0), 0) /
      ratings.length
    : 0; // keep as number for downstream formatting

const feedbackData = {
  supplierId,
  averageRating,
  totalReviews: ratings.length,
  reviews:
    ratings.length > 0
      ? ratings.slice(-2).map((rating) => ({
          customerName: rating?.farmerUser?.name || "Farmer",
          ratingDate: rating?.created_at || "N/A",
          rating: rating?.star_count || 0,
          comment:
            rating?.review_description || "No comment provided",
        }))
      : [],
};




  const customersArray = supplierDetails?.data?.supplier?.supplierOrders?.map((farmer) => ({
    name: farmer?.farmerUser?.name || "N/A", // Use farmer's name or a default value if missing
    imageUrl: farmer?.farmerUser?.profile_image || "default_image_url.png", // Use profile_image or a placeholder
    profileLink: `/farmer/${farmer?.farmerUser?.id}`, // Create a profile link using the farmer's ID
    state: farmer?.farmerUser, // Create a profile link using the farmer's ID
  }));

  // Loading state
  if (isLoading) {
    return (
      <div className="loaderOverlay">
        <img src={Loader} alt="Loader" />
      </div>
    );
  }

  const showLink = true;

  return (
    <Container>
      <Row>
        <Col lg={12} className="breadcrum-container ">
          <Row className="breadcrum-container  py-3">
            <Col lg={12}>
              <div className="custom-breadcrumb">
                {/* <span><a href="/">Home</a></span> */}
                <img src={ICONS.supplier} className="icon" />
                <span>
                  <a href="/suppliers">Suppliers</a>
                </span>
                <span>
                  {userData.name}({userData.id})
                </span>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col lg={12} className="component-container mb-2">
          <UserComponent user={userData} userDetails={userDetailsArray} />
        </Col>

        {productsArray && productsArray.length > 0 && (
          <Col lg={12} className="component-container mb-2">
            <ProductsComponent
              products={productsArray}
              title="Popular Products"
            />
          </Col>
        )}
      </Row>
      {userData.account_status === "Approved" && (
        <>
          <Row className="d-flex justify-content-between two-columns">
            <Col lg={5} className="component-container mb-2">
              <TitleComponent title="Regular Customers" />
              <CustomerComponent customers={customersArray} />
            </Col>

            <Col lg={5} className="component-container mb-2">
              {/* <TitleComponent title="Feedbacks" /> */}
              <FeedbacksComponent
                {...feedbackData}
                showLink={showLink}
                title="Feedbacks"
              />
            </Col>
          </Row>
          <Row>
            <Col lg={12} className="component-container mb-2">
              <TableComponent
                columns={columns}
                data={data}
                title={tableTitle}
                showSearchBar={showSearchBar}
                searchplaceholder={searchplaceholder}
                showFilter={showFilter}
                showTabs={showTabs}
                showColors={showColors}
              />
            </Col>
          </Row>
        </>
      )}
    </Container>
  );
};

export default Supplier;
